import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import BusinessProfile from "../components/BusinessProfile";


function Home() {
    return (
        <div className="d-flex flex-column min-vh-100" style={{ backgroundColor: "#fff" }}>
            <Navbar />
            <BusinessProfile />
            <br></br>
            <br></br>
            <br></br>
            <Footer />

        </div>
    );
}

export default Home;
